import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { TimePicker as BaseTimePicker } from '@mc/react-datetime';
import { useTheme } from '../useTheme';
import { FormItem } from './FormItem';
import classNames from 'classnames';

export type TimePickerProps = VFFieldProps<
  React.ComponentProps<typeof BaseTimePicker>
>;
export const TimePicker = React.forwardRef<HTMLInputElement, TimePickerProps>(
  (
    {
      name,
      label,
      validate,
      className,
      inputClassName,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FormItem
        name={name}
        label={label}
        className={className}
        disabled={disabled}
        required={required}
      >
        <Field name={name}>
          {({ input: { value, onChange, onBlur } }: FieldRenderProps<any>) => {
            return (
              <BaseTimePicker
                {...other}
                className={classNames(
                  `${ns}-time-picker final-form-input-right-visual`,
                  inputClassName
                )}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                onBlur={(newValue) => {
                  onBlur({
                    target: { name, value: newValue },
                  } as any as React.FocusEvent<HTMLElement>);
                }}
                value={value}
                // @ts-ignore
                ref={ref}
                disabled={disabled}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
